import { UCC } from "constant/board";
import { VOD_PLAYER_DOMAIN, DOMAIN } from "constant/config";
import { isWebview, vodInflowLog, getVodPlayerScheme, localStorageFactory, parseBoolean } from "helpers";
import useSearchParams from "components/hook/useSearchParams";

import { isMobile } from "react-device-detect";
import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import cookie from "react-cookies";

const PostLink = ({ children, post, className, bbsNo, inflowPaths, onClick = null, bottomListCheck = false , catchCreated = true, pageType}) => {
    const location = useLocation();
    const history = useHistory();
    // 게시글 정보 조회
    const ucc = post.ucc || {};
    
    // 검색 데이터 조회
    const { page, keyword, orderBy, field, months } = useSearchParams(pageType);

    // 진입 로그 전달
    const handlePassVodInflowLog = useCallback((event) => {
        //이벤트 전파 차단
        event.stopPropagation();
        if (typeof onClick === "function") {
            onClick();
        }
        vodInflowLog(post.user_id, post.title_no, inflowPaths);
    }, [inflowPaths, onClick, post.title_no, post.user_id]);

    const handleCactchVodInflowLog = useCallback(()=>{
        if (typeof onClick === "function") {
            onClick();
        }
        let expires = new Date();
        expires.setSeconds(expires.getSeconds()+10);
        if(isMobile){
            cookie.save("listPreviousUrl", window.location.href, { domain: DOMAIN, path: "/", expires });
        }

        // 내가 만든 캐치만 보기 & 유저가 만든 캐치만 보기
        // let _catchCreated = catchCreated;


        // 캐치 플레이어 진입 로그 전달 데이터 (VIN)
        // isShowUserCrated 캐치 플레이어에서 순서대로 보기 위한 변수
        const catchViewData = {
            'isShowUserCreated' : catchCreated,
            'szStationId' : global.bj_id,
            'szStationOrder' : orderBy
        }

        vodInflowLog(post.user_id, post.title_no, inflowPaths, catchViewData);
    }, [inflowPaths, onClick, post.title_no, post.user_id])

    switch (post.board_type) {
        // 영상 게시글
        case UCC:
            if (isWebview) {
                // 앱내 웹뷰 - 앱내 vod 로 이동
                return (
                    <a
                        href={getVodPlayerScheme(post.station_no,post.bbs_no,post.title_no,ucc.file_type,orderBy)}
                        className={className}
                        onClick={handlePassVodInflowLog}
                    >
                        {children}
                    </a>
                );
            }

            if(ucc.file_type !=="CATCH"){
                return (
                    <a
                        href={`${VOD_PLAYER_DOMAIN}/${post.title_no}`}
                        className={className}
                        target="_blank"
                        rel="noopener"
                        onClick={handlePassVodInflowLog}
                    >
                        {children}
                    </a>
                );
            }
            else{
                return (
                    <a
                    href={`${VOD_PLAYER_DOMAIN}/${post.title_no}/catch`}
                    className={className}
                    target="_blank"
                    rel="noopener"
                    onClick={handleCactchVodInflowLog}
                    >
                        {children}
                    </a>
                )
            }

        // 그 외 일반 게시글
        default:
            return (
                <Link
                    to={{
                        pathname: `/${global.bj_id}/post/${post.title_no}`,
                        search: bottomListCheck ? '' : history.location.search,
                        state: { ...location.state, bbs_no: bbsNo, disableScroll: false },
                    }}
                    onClick={onClick}
                    className={className}
                >
                    {children}
                </Link>
            );
    }
};

export default PostLink;
